import React, { useEffect, useRef } from 'react';
import { Loader } from '@googlemaps/js-api-loader';

const GoogleMap = ({ locations, showPolyline = false }) => {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);

  useEffect(() => {
    const loader = new Loader({
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
      version: 'weekly',
      libraries: ['maps'],
    });

    loader.load().then(() => {
      if (!mapRef.current) return;

      // Create map with a default center (will be adjusted by fitBounds)
      mapInstance.current = new window.google.maps.Map(mapRef.current, {
        zoom: 4,
        mapTypeControl: false,
        fullscreenControl: false,
      });

      // Create bounds object to fit all markers
      const bounds = new window.google.maps.LatLngBounds();

      // Add markers for each location and extend bounds
      locations.forEach((location, index) => {
        new window.google.maps.Marker({
          position: { lat: location.lat, lng: location.lng },
          map: mapInstance.current,
          title: location.name,
          label: {
            text: String(index + 1),
            color: 'white',
            fontSize: '12px',
            fontWeight: 'bold',
          },
        });

        // Extend bounds to include this marker
        bounds.extend({ lat: location.lat, lng: location.lng });
      });

      // Draw polyline connecting locations in order (if enabled)
      if (showPolyline && locations.length > 1) {
        const polylinePath = locations.map(loc => ({
          lat: loc.lat,
          lng: loc.lng,
        }));

        new window.google.maps.Polyline({
          path: polylinePath,
          geodesic: true,
          strokeColor: '#3b82f6',
          strokeOpacity: 0.7,
          strokeWeight: 2,
          map: mapInstance.current,
        });
      }

      // Fit map to show all markers/polyline
      mapInstance.current.fitBounds(bounds);
    });
  }, [locations, showPolyline]);

  return <div ref={mapRef} className="w-full h-64 rounded-lg border border-gray-200" />;
};

export default GoogleMap;

